export const adap_datos_pago_mercado_pago = (datosPago, pedido) =>{

    let obj = {
        nombre: pedido.nombres + ' ' + pedido.apellidos,
        fecha: new Date(datosPago.date_created),
        valor: datosPago.transaction_amount,
        estadoPago: datosPago.status,
        estado: pedido.estado,
        consecutivo: pedido.consecutivo,
        idPedido: pedido.id,
        mensaje: datosPago.status_detail ? datosPago.status_detail : '',
        metodo: datosPago.payment_method_id,
        valorEnvio: pedido.valorEnvio ? pedido.valorEnvio : 0,
        empresaEnvio: pedido.empresaEnvio,
        tiempoEnvio: pedido.tiempoEnvio,
        productos: pedido.productos,
        idTransaccion: datosPago.id,
        celular: pedido.celular,
        valorDescuento: pedido.valorDescuento,
        ciudad: pedido.ciudad,
    }

    return obj
}